import { Svg, type SvgProps } from "./Svg";

export const GreenArrow = ({
	height = "16",
	viewBox = "0 0 23 16",
	width = "23",
	xmlns = "http://www.w3.org/2000/svg",
	...rest
}: SvgProps) => {
	return (
		<Svg {...rest} {...{ height, viewBox, width, xmlns }}>
			<path
				d="M23 1.10702V7.74988C23 8.41416 22.6167 8.85702 22.0417 8.85702C21.4667 8.85702 21.0833 8.41416 21.0833 7.74988V3.76416L13.6083 12.3999C13.225 12.8427 12.65 12.8427 12.2667 12.3999L8.14583 7.63916L1.62917 15.1677C1.4375 15.3892 1.24583 15.4999 0.958333 15.4999C0.670833 15.4999 0.479167 15.3892 0.2875 15.1677C-0.0958333 14.7249 -0.0958333 14.0606 0.2875 13.6177L7.475 5.31416C7.85833 4.87131 8.43333 4.87131 8.81667 5.31416L12.9375 10.0749L19.7417 2.21416H16.2917C15.7167 2.21416 15.3333 1.77131 15.3333 1.10702C15.3333 0.442735 15.7167 -0.00012207 16.2917 -0.00012207H22.0417C22.1375 -0.00012207 22.3292 -0.00012207 22.425 0.110592C22.6167 0.221306 22.8083 0.442735 22.9042 0.664164C23 0.774878 23 0.996306 23 1.10702Z"
				fill="#27AE60"
			/>
		</Svg>
	);
};
